// src/pages/Moderation/UsersViolationsPage/ui/PageHeader/PageHeader.tsx
import React from 'react';
import './PageHeader.scss';

type Props = {
  title: string;
  subtitle?: string;
  onRefresh?: () => void;
};

export const PageHeader: React.FC<Props> = ({ title, subtitle, onRefresh }) => {
  return (
    <div className="uv-header">
      <div>
        <div className="uv-header__title">{title}</div>
        {subtitle && <div className="uv-header__subtitle">{subtitle}</div>}
      </div>

      <div className="uv-header__right">
        {onRefresh && (
          <button type="button" className="uv-header__btn" onClick={onRefresh}>
            Refresh
          </button>
        )}
      </div>
    </div>
  );
};
